export enum EScreenMode {
  Desktop = 'Desktop',
  Mobile = 'Mobile',
}
